@if (progress().length) {
  <aside
    class="fixed bottom-0 right-0 z-40 w-full overflow-hidden border border-primary-100 bg-basic-100 lg:bottom-4 lg:right-4 lg:w-80 lg:rounded-xl rounded-t-xl"
    aria-live="polite"
    aria-label="Painel de processos"
  >
    <div
      class="flex items-center justify-between gap-3 px-4 py-3"
      [class.border-b]="open"
      [class.border-primary-100]="open"
    >
      <div class="flex min-w-0 items-center gap-2.5">
        <div class="flex size-9 shrink-0 items-center justify-center rounded-lg bg-primary-500/10 text-primary-600">
          <span
            class="inline-flex items-center justify-center"
            [class.progress-spinner]="isRunning()"
          >
            <l-icon class="text-xl" icon="progress_activity" aria-hidden="true" />
          </span>
        </div>

        <div class="min-w-0">
          <l-text t="body2" strong="semibold" flow="block" class="text-text-700">Processos</l-text>
          <l-text t="small3" tone="muted" flow="block">Operações em andamento</l-text>
        </div>
      </div>

      <button
        lButton
        bContent="icon"
        bType="light"
        [bSize]="'small'"
        type="button"
        (click)="open = !open"
        [attr.aria-label]="open ? 'Recolher painel de processos' : 'Expandir painel de processos'"
        [attr.aria-expanded]="open"
      >
        <l-icon class="text-xl text-inherit" [icon]="open ? 'keyboard_arrow_down' : 'keyboard_arrow_up'" aria-hidden="true" />
      </button>
    </div>

    @if (open) {
      <div class="max-h-72 space-y-2.5 overflow-y-auto p-3">
        @for (p of progress(); track p.key) {
          <article class="rounded-lg border border-primary-100 bg-primary-500/[0.04] p-3">
            <header class="mb-2 flex items-start justify-between gap-2">
              <l-text t="body3" strong="medium" flow="inline-block" class="min-w-0 flex-1 truncate text-text-700">
                {{ p.name }}
              </l-text>

              @if (p.cancel && !p.canceled) {
                <button
                  type="button"
                  (click)="cancel(p)"
                  lButton
                  bContent="icon"
                  bType="light"
                  [bSize]="'small'"
                  class="shrink-0 text-text-400 hover:text-danger-500"
                  aria-label="Cancelar processo"
                >
                  <l-icon class="text-base text-inherit" icon="close" aria-hidden="true" />
                </button>
              }
            </header>

            <div class="progress-bar relative h-5 w-full">
              <progress
                class="progress-bar__track h-full w-full"
                [class.progress-bar__track--canceled]="p.canceled"
                [value]="progressValue(p)"
                [max]="progressMax(p)"
                [attr.aria-label]="p.name"
              ></progress>

              <div class="progress-bar__label pointer-events-none absolute inset-0 flex items-center justify-center px-2">
                @if (p.loading && !p.canceled) {
                  <l-text t="caption" tone="muted" flow="inline-block" class="truncate">
                    Inicializando...
                  </l-text>
                } @else if (p.canceled) {
                  <l-text t="caption" tone="danger" flow="inline-block" class="truncate">
                    Cancelado
                  </l-text>
                } @else if (p.failed) {
                  <l-text t="caption" tone="danger" flow="inline-block" class="truncate">
                    Falhou
                  </l-text>
                } @else {
                  <l-text
                    t="caption"
                    strong="semibold"
                    flow="inline-block"
                    class="relative z-20 truncate tabular-nums"
                    [class.text-basic-100]="barLabelLight(p)"
                    [class.text-primary-600]="!barLabelLight(p)"
                  >
                    {{ p.current }} de {{ p.total }}
                  </l-text>
                }
              </div>
            </div>

            @if (p.failed && p.retry) {
              <button
                type="button"
                lButton
                bType="primary"
                [bSize]="'small'"
                class="mt-2 w-full"
                (click)="retry(p)"
              >
                Tentar novamente
              </button>
            }
          </article>
        }
      </div>
    }
  </aside>
}
